//Angular
import { Component, OnInit, ViewContainerRef, Inject, Compiler, Input } from "@angular/core";

//System
import { Mappings } from './../../../../../../shared/mapping';
import { TranslateService } from '@ngx-translate/core';

//Services
import { ComponentHelperService } from "./../../../../../../services/core/component-helper.service";
import { QuotingService } from "./../../../../../../services/document/quoting.service";
import { LanguageService } from "./../../../../../../services/cms/language.service";
import { AuthService } from "./../../../../../../services/core/auth.service";
import { TemplateService } from "./../../../../../../services/settings/template.service";
import { BootboxService } from './../../../../../../services/core/bootbox.service';
import { ShoppingCartService } from "./../../../../../../services/inventory/shopping-cart.service";
import { RoutesService } from "./../../../../../../services/core/routes.service";
//Components
import { ExcludingComponent } from "./../../../../../../components/document/widget/quoting/quoting-excluding.component";

//Models
import { QuotingModel } from "./../../../../../../models/document/quoting-model";
import { Object } from "./../../../../../../models/document/quoting-model";
import { LavorazioniAccessorieModel } from "./../../../../../../models/document/quoting-submit-model";
import { UserLogin } from "./../../../../../../models/cms/user-login";
import { PriceEstimationModel } from "./../../../../../../models/document/quoting-submit-model";
import { FileCombinationModel } from "./../../../../../../models/document/quoting-submit-model";
import { wizardFormEditoriaModel } from "./../../../../../../models/document/quoting-submit-model";

import { Subscription } from 'rxjs/Subscription';
import { CustomersCanvasService } from "../../../../../../services/inventory/customerscanvas.service";

@Component({
  selector: "dy-wizard-commerciale-widget",
  template: ""
})


export class WizardCommercialeComponent implements OnInit {
  constructor
    (
      private _compiler: Compiler,
      private componentHelper: ComponentHelperService,
      private _elementRef: ViewContainerRef,
      private _quotingService: QuotingService,
      private authService: AuthService,
      private languageService: LanguageService,
      @Inject('isBrowser') private isBrowser: boolean
    ) { }

  @Input() resourceId: number;
  autentification = this.authService.GetData();
  private userId = this.authService.GetUserId();
  lang: string = this.languageService.getLongLang();

  subManager = new Subscription();

  ngOnInit() {
    if (!this.isBrowser)
      return;
    let sub = this._quotingService.getWizardCommercialeData("PREVENTIVATORE_WIZARD", this.resourceId, this.userId, this.lang).subscribe(result => {
      //Creating subcomponent whith the selected template to inject
      let subComponent = this.createSubComponent(result, this.resourceId);

      //injecting created component (OK)
      this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
    });

    this.subManager.add(sub);
  }

  ngOnDestroy() {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subManager.unsubscribe();
  }

  private createSubComponent(result: any, InputresourceId: number) {
    @Component({
      template: result.templateHtml
    })

    class ChildComponent implements OnInit {
      constructor
        (
          private _quotingService: QuotingService,
          private languageService: LanguageService,
          private authService: AuthService,
          private translate: TranslateService,
          private cartService: ShoppingCartService,
          private routesService: RoutesService,
          private bootboxService: BootboxService,
          @Inject('isBrowser') private isBrowser: boolean,
          public canvasService: CustomersCanvasService
        ) {
        //check if modal is opened or not, so we can stick or unstick quoting div (if it is stick and modal is opened, there is a layout error, so we need to unstick it)
        const canvasSub = canvasService.isCanvasModalOpened$
          .subscribe(
            isModalOpened => {
              if (isModalOpened == false) {
                $('html').css("overflow", "visible");
              }
              else {
                // before open of canvas editor, we scroll to the top and set overflow to hidden because of problem with sticky plugin
                window.scrollTo(0, 0);
                $('html').css("overflow", "hidden");
              }
            });

        // after canvas product design is aproved from a child component (canvas-widget.component.ts), we want to add a product in a cart
        const canvasEditedSub = canvasService.isCanvasProductDesignApproved$
          .subscribe(
            isDesignApproved => {
              if (isDesignApproved) {
                $('#customerCanvasModal').modal('hide');
                $('html').css("overflow", "visible");
                // set for product info that it is edited in canvas, so we know if we should pass canvas data to the server or not
                cartService.setIfProductIsCanvasEdited(true);

                if (this.isCalculationTypeCalcolato()) {
                  this.addToCartWizardCalcolato(1);
                }
                else if (this.isCalculationTypeCalcolatoScontistica()) {
                  this.addToCartWizardCalcolatoScontistica(1);
                }
                else if (this.isCalculationTypeListino()) {
                  this.addToCartWizardListino(1);
                }
                else if (this.isCalculationTypeListinoScontistica()) {
                  this.addToCartWizardListinoScontistica(1);
                }
              }
            });

        this.subManager.add(canvasSub);
        this.subManager.add(canvasEditedSub);
      }

      private pageIsInit: boolean = false;
      private pageIsInitAfter: boolean = false;
      private loggedIdUser: UserLogin;
      private privacyPageName: string[] = this.routesService.getRoutePath('INFO PRIVACY');
      private purchasePageName: string[] = this.routesService.getRoutePath('INFO CONDIZIONI DI VENDITA');
      waiting: boolean = false;
      carteValue: number = -1;
      lang: string = this.languageService.getLongLang();
      responseModel: QuotingModel = new QuotingModel();
      autentification = this.authService.GetData();
      resourceId: number = InputresourceId;
      isDataInitialized: boolean = false;
      iShowHourForDay: boolean = false;
      resultPrice: PriceEstimationModel = new PriceEstimationModel();
      ExcludingRules: ExcludingComponent = new ExcludingComponent();
      typePriceResult: string;
      model = new wizardFormEditoriaModel();
      currentRowIndex: number = -1;
      currentColumnIndex: number = -1;
      requestInfoSuccess: boolean = null;
      resultCalculation: boolean = false;
      showErrorMessage: boolean = false;
      listaFile: Array<FileCombinationModel>;
      blockquoting: boolean = false;
      listaProfonditaPackaging: Array<any> = new Array<any>();
      listaFormatiFull: Array<Object> = new Array<Object>();

      isCalculatedWizard: boolean = false;

      // sending info to a child component
      public parentWidgetData: string = result.CanvasInfo;

      subManager = new Subscription();

      ngOnInit() {
        var array = ["1", "2", "3"];
        this.resultPrice.TablePriceList = new Array<any>();
        this.resultPrice.TablePriceList.push(array);
        this.resultPrice.TableScontisticaPriceList = new Array<Array<any>>();
        this.resultPrice.TableScontisticaPriceList.push(array);

        this.ExcludingRules.setMacrocategory("COMMERCIALE");
        this.loggedIdUser = this.authService.GetData();
        this.responseModel = new QuotingModel();
        this.responseModel = result;
        this.responseModel.taglioShowed = this.responseModel.tipoTaglio;
        this.responseModel.isTaglioVisible = false;
        this.typePriceResult = "no-tax";
        this.responseModel.valueStampaInternoSoloFronte = false;
        this.responseModel.valueStampaCopertinaSoloFronte = false;
        this.listaFormatiFull = this.responseModel.formati;

        if (this.responseModel.IsPackagingWizard == true) {
          this.onBasePackagingChange();
        }
        else {
          if (!this.isDataInitialized) {
            //check if the all values is validated
            this.parameterValidation()
          }
        }
        setInterval(() => {
          if (this.isDataInitialized) {
          this.parameterValidation();
          }
      }, 300000); //5 minutes
        //this.parameterValidation();},60000); //1 minutes
      }

      checkFirstDayForHour(priceList: any) {
        for (let priceRow of priceList) {
          var result = false;
          if (!priceRow.IsHour) {
            if (!this.iShowHourForDay) {
              this.iShowHourForDay = true;
              result = true;
            }
          }
          priceRow.iShowHourForDay = result;
        }
      }
      openCanvasEditor() {
        if (result.CanvasInfo.TemplateImagesFolderPath) {
          $('html').css("overflow", "hidden");

          const canvasConfigData = this.setCanvasConfig();
          // because here we don't have a state id, it is a new product
          const isStateId = false;

          this.canvasService.openCanvasEditor(canvasConfigData, isStateId);
        }
      }

      setCanvasConfig() {
        const canvasConfigData = {
          CanvasUrl: result.CanvasInfo.CanvasUrl,
          TemplateImagesFolderPath: result.CanvasInfo.TemplateImagesFolderPath,
          CustomerCanvasUserName: result.CanvasInfo.CustomerCanvasUserName,
          Watermark: result.CanvasInfo.WatermarkText
        };

        return canvasConfigData;
      }

      toShowCanvasButton() {
        let toShow = false;
        let isModuleActive = false;
        let isUserLoggedIn = false;

        if (result.CanvasInfo && result.CanvasInfo.IsActiveCanvasModule) {
          isModuleActive = result.CanvasInfo.IsActiveCanvasModule;
        }

        if (this.loggedIdUser != null && this.loggedIdUser.isAuthenticated != null) {
          isUserLoggedIn = this.loggedIdUser.isAuthenticated;
        }

        toShow = isModuleActive && isUserLoggedIn ? true : false;

        return toShow;
      }

      CheckRegoleCommerciale() {
        try {
          this.blockquoting = false;
          //save in the array all parameter value before to apply rules
          let oldCarta = this.responseModel.idCarte1;
          let oldFormato = this.responseModel.idFormati;
          let oldPlastificazione = this.responseModel.idPlastificazioni1;
          let oldPiegature = this.responseModel.idPiegature;
          let lavAccArray = new Array<LavorazioniAccessorieModel>();
          for (let lavorazione of this.responseModel.lavorazioniAccessorie) {
            let lav: LavorazioniAccessorieModel = new LavorazioniAccessorieModel();
            if (lavorazione.tipo == "2") {
              lav.lavorazioneId = lavorazione.id;
              lav.valoreLavorazione = lavorazione.valore;
              lavAccArray.push(lav);
            }
          }

          //-----------------------------------------------------------------------------//
          //-----------------------------Reset delle regole------------------------------//
          //-----------------------------------------------------------------------------//
          this.ExcludingRules.ResetRegole("PF", "FINITURA", "FORMATO", "COMMERCIALE", null, null, this.responseModel);

          //Reset regole carta e grammature
          this.ExcludingRules.ResetRegole("PF", "CARTA", "", "", null, null, this.responseModel);

          //Reset regole plastificazione
          this.ExcludingRules.ResetRegole("PF", "FINITURA", "PIEGATURA", "", null, null, this.responseModel);

          //Reset regole plastificazione
          this.ExcludingRules.ResetRegole("PF", "FINITURA", "PLASTIFICAZIONE", "COMMERCIALE", null, null, this.responseModel);

          //Reset regole taglio
          this.ExcludingRules.ResetRegole("PF", "FINITURA", "TAGLIO", "COMMERCIALE", null, null, this.responseModel);

          //Reset regole accessorie
          this.ExcludingRules.ResetRegole("PF", "ACCESSORIA", "", "COMMERCIALE", null, null, this.responseModel);


          //-----------------------------------------------------------------------------//
          //----------------------Applicazione delle regole------------------------------//
          //-----------------------------------------------------------------------------//

          this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "FORMATO", "COMMERCIALE", this.responseModel.idFormati, 0, this.responseModel);

          if (this.responseModel.idCarte1 != null) {
            var data = this.responseModel.idCarte1.split("_");
            let idCarta = data[0];

            this.ExcludingRules.ApplicaRegole("PF", "CARTA", "", "", idCarta, 0, this.responseModel);
            this.ExcludingRules.ApplicaRegole("PF", "CARTA", "", "", idCarta, this.responseModel.idGrammature1, this.responseModel);
          }

          this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "PLASTIFICAZIONE", "COMMERCIALE", this.responseModel.idPlastificazioni1, 0, this.responseModel);

          this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "PIEGATURA", "", this.responseModel.idPiegature, 0, this.responseModel);

          if (!this.isTaglioCalculated()) {
            this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "TAGLIO", "COMMERCIALE", 1, 0, this.responseModel);
          }
          else {
            this.ExcludingRules.ApplicaRegole("PF", "FINITURA", "TAGLIO", "COMMERCIALE", 2, 0, this.responseModel);
          }

          this.ExcludingRules.ApplicaRegoleLavorazioniAccessorie("PF", "COMMERCIALE", this.responseModel);
          //if the old value id different to the new one i call the method for update description and image
          if (oldFormato != this.responseModel.idFormati) {
            this.onFormatiChange(true);
          }
          if (oldCarta != this.responseModel.idCarte1) {
            this.onCartaInternoFieldChanged(true);
          }
          if (oldPlastificazione != this.responseModel.idPlastificazioni1) {
            this.onPlastificationInternoChange(true);
          }
          if (oldPiegature != this.responseModel.idPiegature) {
            this.onPiegaturaChange(true);
          }
          let count = 0;
          for (let lavorazione of this.responseModel.lavorazioniAccessorie) {
            count = 0;
            for (let lavorazioneOld of lavAccArray) {
              if (count > 0) {
                continue;
              }
              else {
                if (lavorazione.tipo == "2") {
                  if (lavorazione.isVisible == true) {
                    if ((lavorazione.id == lavorazioneOld.lavorazioneId)) {
                      if ((lavorazione.valore != lavorazioneOld.valoreLavorazione)) {
                        this.lavorazioniAccessorieComboChange(lavorazione, true);
                        count++;
                      }
                    }
                  }
                }
              }
            }
          }
        } catch (e) {
          this.blockquoting = true;
          this.showErrorMessage = true;
          return;
        }
      }

      parameterValidation() {
        this.iShowHourForDay = false;
        this.isCalculatedWizard = false;
        this.resultCalculation = false;
        this.showErrorMessage = false;
        this.requestInfoSuccess = null;

        //apply all rules
        this.CheckRegoleCommerciale();

        //verify validation for all  parameters 
        this.validationCopie();

        if (this.responseModel.soggettiMultipli == true) {
          this.validationSoggetti();
        }
        else {
          this.responseModel.soggettiIsValid = true;
        }

        if (this.responseModel.IsPackagingWizard == true) {
          this.validationBasePackaging();
          this.validationProfonditaPackaging();
        }
        else {
          this.responseModel.basePackagingIsValid = true;
          this.responseModel.profonditaPackagingIsValid = true;
        }

        this.validationFormati();

        if (this.responseModel.idFormati == "0") {
          this.validationBaseFormati();
          this.validationAltezzaFormati();
        }
        else {
          this.responseModel.baseFormatoIsValid = true;
          this.responseModel.altezzaFormatoIsValid = true;
        }

        this.validationColori();

        this.validationCarteInterno();
        this.validationGrammatureCarteInterno();

        this.validationPiegatura();
        this.validationPlastificazione();
        this.validationLavorazioneAccessoria();

        this.countCartaCategories()

        if (this.responseModel.ManageAttachment == "Combinazioni") {
          this.selectFileCombination();
        }

        //if all parameters are validated  call a method who getting price
        if (this.checkValidation()) {
          $('#quotingFormCalculationLoader').addClass("overBlock");
          this.getCalculationModel();
        }
        else {
          $('#quotingFormCalculationLoader').removeClass("overBlock");
          this.resultCalculation = true;
          this.showErrorMessage = true;
        }
      }

      countCartaCategories() {
        if (this.responseModel.categorieCarte != null) {
          this.responseModel.categorieCarteCount = this.responseModel.categorieCarte.filter(x => x.isVisible == true).length;
        }
      }

      checkZero(val) {
        if (val == "" || val == null) {
          return "0";
        }
        else {
          return val;
        }
      }

      setTypePriceResult(type) {
        this.typePriceResult = type;
        if (type == "tax") {
          $("#btnNoIva").removeClass("active");
          $("#btnIva").addClass("active");
        }
        else {
          $("#btnNoIva").addClass("active");
          $("#btnIva").removeClass("active");
        }
      }

      isRowSelected(rowIndex: number) {
        let result: boolean = false;

        if ((rowIndex + 1) == this.currentRowIndex) {
          result = true;
        }

        return result;
      }

      isCellSelected(rowIndex: number, columnIndex: number) {
        let result: boolean = false;

        if ((rowIndex + 1) == this.currentRowIndex && (columnIndex + 1) == this.currentColumnIndex) {
          result = true;
        }

        return result;
      }

      isColumnSelected(columnIndex: number) {
        let result: boolean = false;

        if ((columnIndex + 1) == this.currentColumnIndex) {
          result = true;
        }

        return result;
      }

      setSelectedIndex(rowIndex: number, columnIndex: number) {
        this.currentRowIndex = rowIndex;
        this.currentColumnIndex = columnIndex;
      }

      clearSelectedIndex() {
        this.currentRowIndex = -1;
        this.currentColumnIndex = -1;
      }

      isRowSelectedListino(rowIndex: number) {
        let result: boolean = false;

        if ((rowIndex) == this.currentRowIndex) {
          result = true;
        }

        return result;
      }

      isCellSelectedListino(rowIndex: number, columnIndex: number) {
        let result: boolean = false;

        if ((rowIndex) == this.currentRowIndex && (columnIndex) == this.currentColumnIndex) {
          result = true;
        }

        return result;
      }

      isColumnSelectedListino(columnIndex: number) {
        let result: boolean = false;

        if ((columnIndex) == this.currentColumnIndex) {
          result = true;
        }

        return result;
      }

      setSelectedIndexListino(rowIndex: number, columnIndex: number) {
        this.currentRowIndex = rowIndex;
        this.currentColumnIndex = columnIndex;
      }

      /// Create model for passed in input to the calculation method
      getCalculationModel() {
        this.model.macrocategoryWizardId = this.responseModel.idGruppo;
        this.model.tipoCopie = this.responseModel.tipoCopie;

        if (this.responseModel.tipoCopie != 'libera') {
          this.model.idCopie = this.responseModel.idCopie;
        }
        else {
          this.model.numCopie = this.responseModel.numCopie;
        }

        this.model.soggettiMultipli = this.responseModel.soggettiMultipli;
        this.model.numSoggetti = this.responseModel.numSoggetti;

        this.model.idCarte1 = this.responseModel.idCarte1;

        for (let carta of this.responseModel.carte1) {
          if (this.model.idCarte1 == carta.chiave) {
            this.model.nomeCarte1 = carta.valore
          }
        }
        this.model.idGrammature1 = this.responseModel.idGrammature1;

        for (let grammatureInterno of this.responseModel.grammature1) {
          if (this.model.idGrammature1 == grammatureInterno.chiave) {
            this.model.nomeGrammature1 = grammatureInterno.valore
          }
        }

        this.model.StrCustomerId = this.authService.GetUserId();
        this.model.wizardId = this.resourceId;
        this.model.idFormati = this.responseModel.idFormati;

        if (this.responseModel.idFormati == "0") {
          this.model.baseFormato = this.responseModel.baseFormato;
          this.model.altezzaFormato = this.responseModel.altezzaFormato;
        }

        this.model.idColori1 = this.responseModel.idColori1;

        if (this.model.idColori1 != "1" && this.model.idColori1 != "2") {
          this.model.stampa1_colori_fronte = this.responseModel.stampa1_colori_fronte;
          this.model.stampa1_colori_retro = this.responseModel.stampa1_colori_retro;
        }

        this.model.idColori2 = this.responseModel.idColori2;

        if (this.responseModel.isPlastificazioneRequired == false && this.responseModel.idPlastificazioni1 == "-1") {
          this.model.idPlastificazioni1 = ""
        }
        else {
          this.model.idPlastificazioni1 = this.responseModel.idPlastificazioni1;
        }

        this.model.taglio = this.isTaglioCalculated();

        if (this.responseModel.idPiegature != "-1") {
          this.model.idPiegature = this.responseModel.idPiegature;
        }

        this.model.lavorazioniAccessorie = new Array<LavorazioniAccessorieModel>();

        for (let lavorazioneAccessoria of this.responseModel.lavorazioniAccessorie) {
          let lavorazione: LavorazioniAccessorieModel = new LavorazioniAccessorieModel();
          if (lavorazioneAccessoria.isVisible == true) {

            //checkbox
            if (parseInt(lavorazioneAccessoria.tipo) == 0) {
              lavorazione.lavorazioneId = lavorazioneAccessoria.id;
              if (lavorazioneAccessoria.lavorazioneCheckValue.toString() == 'true') {
                lavorazione.valoreLavorazione = "1";
              }
              else {
                lavorazione.valoreLavorazione = "0";
              }
            }
            //combo
            else if (parseInt(lavorazioneAccessoria.tipo) == 2) {
              if (lavorazioneAccessoria.valore != "-1") {
                if (lavorazioneAccessoria.valore != "0") {
                  lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                  lavorazione.valoreLavorazione = lavorazioneAccessoria.valore;
                }
              }
            }
            //numeric
            else if (parseInt(lavorazioneAccessoria.tipo) == 1) {
              if (lavorazioneAccessoria.value != null) {
                lavorazione.lavorazioneId = lavorazioneAccessoria.id;
                if (lavorazioneAccessoria.value != "0") {
                  lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
                }
              }
            }
            //text area
            else if (parseInt(lavorazioneAccessoria.tipo) == 6) {
              lavorazione.lavorazioneId = lavorazioneAccessoria.id;
              lavorazione.valoreLavorazione = lavorazioneAccessoria.value;
            }

            if (lavorazione.lavorazioneId != null) {
              this.model.lavorazioniAccessorie.push(lavorazione);
            }
          }
        }

        this.model.lavorazioniAccessorie.sort((a, b) => 0 - (a > b ? -1 : 1));

        if (this.responseModel.calculationType != "calcolato_richiesta_preventivo") {
          let sub = this._quotingService.getCalculatedWizard(this.model).subscribe(result => {
            this.resultPrice = result;
            this.isCalculatedWizard = true;

            if (this.isCalculationTypeCalcolatoScontistica()) {
              var scontisticaTable = this.resultPrice.TablePriceList;
              this.checkFirstDayForHour(scontisticaTable);
              if (scontisticaTable != null && scontisticaTable.length > 0) {
                //Selecting the last available day result. (The cheapest)
                for (let i = scontisticaTable.length - 1; i >= 0; i--) {
                  let price = scontisticaTable[i];
                  if (price.Price != -1) {
                    this.setPriceResult(price);
                    break;
                  }
                }
              }
            }
            else if (this.isCalculationTypeListinoScontistica()) {
              //Selecting first element
              let tableScontisticaPriceListSliced = this.resultPrice.TableScontisticaPriceList.slice(1);
              let breakFlag = false;
              for (let priceRow of tableScontisticaPriceListSliced) {
                let slicedPriceRow = priceRow.slice(1);
                this.checkFirstDayForHour(slicedPriceRow);
                //reverse the obj for select the last data and first price available
                var reverse = slicedPriceRow.reverse();
                for (let price of reverse) {
                  if (price.Price != -1) {
                    this.setListinoScontisticaPriceResult(price);
                    breakFlag = true;
                    break;
                  }
                }

                if (breakFlag == true) {
                  break;
                }
              }
            }
            else if (this.isCalculationTypeListino()) {
              let tableScontisticaPriceListSliced = this.resultPrice.TablePriceList;
              this.checkFirstDayForHour(tableScontisticaPriceListSliced);
              if (tableScontisticaPriceListSliced.length > 0) {
                let slicedPriceRow = tableScontisticaPriceListSliced[0];
                if (slicedPriceRow.Price != -1) {
                  this.setListinoPriceResult(slicedPriceRow);
                }
              }
            }

            this.subManager.add(sub);

            this.resultCalculation = true;
            this.showErrorMessage = false;
            $('#quotingFormCalculationLoader').removeClass("overBlock");
          },
            err => {
              this.showErrorMessage = true;
              this.isCalculatedWizard = true;
              $('#quotingFormCalculationLoader').removeClass("overBlock");
            }
          );
        }
        else {
          this.resultCalculation = true;
          this.showErrorMessage = false;
          $('#quotingFormCalculationLoader').removeClass("overBlock");

        }

        this.isDataInitialized = true;
      }

      ngAfterViewInit() {
        if (!this.isBrowser || this.pageIsInit) {
          return;
        }

        $('#quotingFormLoader').hide();
        var $wrapper = $('#listWizard');

        $wrapper.find('.sortable-div ').sort(function (a, b) {
          return +a.dataset.order - +b.dataset.order;
        }).appendTo($wrapper);

        let altezza = $("#footer").outerHeight();
        let margintop = parseInt($("#footer").css('margin-top'));
        let paddingntop = parseInt($("#footer").css('padding-top'));
        altezza += margintop;
        altezza += paddingntop;

        let altezza1 = $(".footerplus").outerHeight() || 0;
        let margintop1 = parseInt($(".footerplus").css('margin-top')) || 0;
        let paddingntop1 = parseInt($(".footerplus").css('padding-top')) || 0;
        altezza += altezza1;
        altezza += margintop1;
        altezza += paddingntop1;

        let altezzaHead = $(".header-body").outerHeight();
        let margintopHead = parseInt($(".header-body").css('margin-bottom'));
        let paddingntopHead = parseInt($(".header-body").css('padding-bottom'));
        altezzaHead += margintopHead;
        altezzaHead += paddingntopHead;

        $("#quotingInformationTab").sticky({ topSpacing: altezzaHead, bottomSpacing: altezza });
        $("#quotingInformationTab-sticky-wrapper").height(0);

        this.pageIsInit = true;
      }

      checkValidation() {
        if (this.responseModel.copieIsValid
          && this.responseModel.formatiIsValid
          && this.responseModel.carte1IsValid
          && this.responseModel.grammature1IsValid
          && this.responseModel.piegatureIsValid
          && this.responseModel.plastificazione1IsValid
          && this.responseModel.lavorazioniIsValid
          && this.responseModel.baseFormatoIsValid
          && this.responseModel.altezzaFormatoIsValid
          && this.responseModel.soggettiIsValid
          && this.responseModel.colori1IsValid
          && this.responseModel.basePackagingIsValid
          && this.responseModel.profonditaPackagingIsValid
        ) {
          return true;
        }
        else {
          return false;
        }
      }

      validationColori() {
        let message;

        if (this.responseModel.idColori1 == "-1") {
          message = this.getLabel('mandatory_field');
          this.responseModel.colori1IsValid = false;
        }
        else {
          this.responseModel.colori1IsValid = true;
        }

        if (this.responseModel.colori1 != null) {
          this.responseModel.colori1Count = this.responseModel.colori1.filter(x => x.isVisible == true).length;
        }

        if (this.responseModel.colori2 != null) {
          this.responseModel.colori2Count = this.responseModel.colori2.filter(x => x.isVisible == true).length;
        }

        this.responseModel.colori1Message = message;
      }


      validationBaseFormati() {
        let message;
        let base = parseFloat(this.responseModel.baseFormato.replace(",", "."))
        //let base = parseFloat(this.responseModel.baseFormato)
        let minBase = this.responseModel.minimoBase;
        let maxBase = this.responseModel.massimoBase;
        if (minBase > 0 || maxBase > 0) {
          if (minBase > 0 && maxBase == 0) {
            if ((base >= minBase)) {
              this.responseModel.baseFormatoIsValid = true;
            }
            else {
              message = this.getLabel('inserisci_valore_maggiore');
              message += " " + minBase;
              this.responseModel.baseFormatoIsValid = false;
            }
          }
          else if (minBase == 0 && maxBase > 0) {
            if ((base <= maxBase)) {
              this.responseModel.baseFormatoIsValid = true;
            }
            else {
              message = this.getLabel('inserisci_valore_compreso_tra');
              message += " " + minBase;
              message += " " + this.getLabel('inserisci_valore_compreso_e');
              message += " " + maxBase;
              this.responseModel.baseFormatoIsValid = false;
            }
          }
          else if (minBase > 0 && maxBase > 0) {
            if ((base >= minBase) && (base <= maxBase)) {
              this.responseModel.baseFormatoIsValid = true;
            }
            else {
              message = this.getLabel('inserisci_valore_compreso_tra');
              message += " " + minBase;
              message += " " + this.getLabel('inserisci_valore_compreso_e');
              message += " " + maxBase;
              this.responseModel.baseFormatoIsValid = false;
            }
          }
        }
        else {
          if (base <= 0 || this.responseModel.baseFormato == null) {
            message = this.getLabel('inserisci_valore_maggiore');
            message += " " + 0;
            this.responseModel.baseFormatoIsValid = false;
          }
          else {
            this.responseModel.baseFormatoIsValid = true;
          }
        }
        this.responseModel.baseFormatoMessage = message;
      }

      validationAltezzaFormati() {
        let message;
        let altezza = parseFloat(this.responseModel.altezzaFormato.replace(",", "."))
        let minAltezza = this.responseModel.minimoAltezza;
        let maxAltezza = this.responseModel.massimoAltezza;
        if (minAltezza > 0 || maxAltezza > 0) {
          if (minAltezza > 0 && maxAltezza == 0) {
            if ((altezza >= minAltezza)) {
              this.responseModel.altezzaFormatoIsValid = true;
            }
            else {
              message = this.getLabel('inserisci_valore_maggiore');
              message += " " + minAltezza;
              this.responseModel.altezzaFormatoIsValid = false;
            }
          }
          else if (minAltezza == 0 && maxAltezza > 0) {
            if ((altezza <= maxAltezza)) {
              this.responseModel.altezzaFormatoIsValid = true;
            }
            else {
              message = this.getLabel('inserisci_valore_compreso_tra');
              message += " " + minAltezza;
              message += " " + this.getLabel('inserisci_valore_compreso_e');
              message += " " + maxAltezza;
              this.responseModel.altezzaFormatoIsValid = false;
            }
          }
          else if (minAltezza > 0 && maxAltezza > 0) {
            if ((altezza >= minAltezza) && (altezza <= maxAltezza)) {
              this.responseModel.altezzaFormatoIsValid = true;
            }
            else {
              message = this.getLabel('inserisci_valore_compreso_tra');
              message += " " + minAltezza;
              message += " " + this.getLabel('inserisci_valore_compreso_e');
              message += " " + maxAltezza;
              this.responseModel.altezzaFormatoIsValid = false;
            }
          }
        }
        else {
          if (altezza <= 0 || this.responseModel.altezzaFormato == null) {
            message = this.getLabel('inserisci_valore_maggiore');
            message += " " + 0;
            this.responseModel.altezzaFormatoIsValid = false;
          }
          else {
            this.responseModel.altezzaFormatoIsValid = true;
          }
        }

        this.responseModel.altezzaFormatoMessage = message;
      }

      validationSoggetti() {
        let message;
        let numSoggetti = parseInt(this.responseModel.numSoggetti);

        if (this.responseModel.numSoggetti == null) {
          message = this.getLabel('inserisci_valore_valido');
          this.responseModel.soggettiIsValid = false;
        }
        else if (numSoggetti == 0) {
          message = this.getLabel('inserisci_valore_maggiore_0');
          this.responseModel.soggettiIsValid = false;
        }
        else {
          this.responseModel.soggettiIsValid = true;
        }

        this.responseModel.soggettiMessage = message;
      }

      validationCopie() {
        let message;

        if (this.responseModel.tipoCopie == 'libera') {
          let numCopie = parseInt(this.responseModel.numCopie);
          let minCopie = this.responseModel.minimoCopie;
          let maxCopie = this.responseModel.massimoCopie;

          if (this.responseModel.numCopie == null) {
            message = this.getLabel('inserisci_valore_valido');
            this.responseModel.copieIsValid = false;
          }
          else if (maxCopie == 0) {
            if (numCopie < minCopie) {
              message = this.getLabel('inserisci_valore_maggiore');
              message += " " + minCopie;
              this.responseModel.copieIsValid = false;
            }
            else {
              this.responseModel.copieIsValid = true;
            }
          }
          else {
            if ((numCopie >= minCopie) && (numCopie <= maxCopie)) {
              this.responseModel.copieIsValid = true;
            }
            else {
              message = this.getLabel('inserisci_valore_compreso_tra');
              message += " " + minCopie;
              message += " " + this.getLabel('inserisci_valore_compreso_e');
              message += " " + maxCopie;
              this.responseModel.copieIsValid = false;
            }
          }
        }
        else {
          if (this.responseModel.idCopie == "-1") {
            message = this.getLabel('mandatory_field');
            this.responseModel.copieIsValid = false;
          }
          else {
            this.responseModel.copieIsValid = true;
          }

          if (this.responseModel.tipoCopie === 'fissa' && this.responseModel.copie != null) {
            this.responseModel.copieCount = this.responseModel.copie.filter(x => x.isVisible == true).length;
          }
        }

        this.responseModel.copieMessage = message;
      }

      validationBasePackaging() {
        let message;

        if (this.responseModel.idBasePackaging == 0 || this.responseModel.idBasePackaging == null) {
          message = this.getLabel('mandatory_field');
          this.responseModel.basePackagingIsValid = false;
        }
        else {
          this.responseModel.basePackagingIsValid = true;
        }

        this.responseModel.basePackagingMessage = message;
      }

      validationProfonditaPackaging() {
        let message;

        if (this.responseModel.idProfonditaPackaging == 0 || this.responseModel.idProfonditaPackaging == null) {
          message = this.getLabel('mandatory_field');
          this.responseModel.profonditaPackagingIsValid = false;
        }
        else {
          this.responseModel.profonditaPackagingIsValid = true;
        }

        this.responseModel.profonditaPackagingMessage = message;
      }

      validationFormati() {
        let message;

        if (this.responseModel.idFormati == "-1") {
          message = this.getLabel('mandatory_field');
          this.responseModel.formatiIsValid = false;
        }
        else {
          this.responseModel.formatiIsValid = true;
        }

        this.responseModel.formatiMessage = message;

        if (this.responseModel.formati != null) {
          this.responseModel.formatiCount = this.responseModel.formati.filter(x => x.isVisible == true).length;
        }

      }

      validationCarteInterno() {
        let message;

        if (this.responseModel.idCarte1 == "-1") {
          message = this.getLabel('mandatory_field');
          this.responseModel.carte1IsValid = false;
        }
        else {
          this.responseModel.carte1IsValid = true;
        }

        if (this.responseModel.carte1 != null) {
          this.responseModel.carte1Count = this.responseModel.carte1.filter(x => x.isVisible == true).length;
        }

        this.responseModel.carte1Message = message;
      }

      validationGrammatureCarteInterno() {
        let message;

        if (this.responseModel.idGrammature1 == "-1") {
          message = this.getLabel('mandatory_field');
          this.responseModel.grammature1IsValid = false;
        }
        else {
          this.responseModel.grammature1IsValid = true;
        }

        if (this.responseModel.grammature1 != null) {
          this.responseModel.grammature1Count = this.responseModel.grammature1.filter(x => x.isVisible == true).length;
        }

        this.responseModel.grammature1Message = message;
      }

      validationLavorazioneAccessoria() {
        let message: string = "";
        let valid: boolean = true;

        for (let lavorazione of this.responseModel.lavorazioniAccessorie) {
          if (lavorazione.tipo == "2" && lavorazione.isVisible) {
            if (lavorazione.obbligatorio == true) {
              if (lavorazione.valore == "-1") {
                message = this.getLabel('mandatory_field');
                lavorazione.isValid = false;
                valid = false;
              }
              else {
                lavorazione.isValid = true;
              }
            }

            lavorazione.lavorazioneMessage = message;
          }
          //check min qta  and max qta  for input field
          if (lavorazione.tipo == "1" && lavorazione.isVisible) {
            let qta = parseInt(lavorazione.value);
            let minQta = lavorazione.minQtaInput;
            let maxQta = lavorazione.maxQtaInput;

            if (lavorazione.value == null) {
              message = this.getLabel('inserisci_valore_valido');
              lavorazione.isValid = false;
              valid = false;
            }
            else if (maxQta == 0) {
              if (qta < minQta) {
                message = this.getLabel('inserisci_valore_maggiore');
                message += " " + minQta;
                lavorazione.isValid = false;
                valid = false;
              }
              else {
                lavorazione.isValid = true;
              }
            }
            else {
              if ((qta >= minQta) && (qta <= maxQta)) {
                lavorazione.isValid = true;
              }
              else {
                message = this.getLabel('inserisci_valore_compreso_tra');
                message += " " + minQta;
                message += " " + this.getLabel('inserisci_valore_compreso_e');
                message += " " + maxQta;
                lavorazione.isValid = false;
                valid = false;
              }
            }
            lavorazione.lavorazioneMessage = message;
          }

          if (lavorazione.valori != null) {
            lavorazione.valoriCount = lavorazione.valori.filter(x => x.isVisible == true).length;
          }
        }

        this.responseModel.lavorazioniIsValid = valid;
      }

      validationPiegatura() {
        let message;

        if (this.responseModel.idPiegature == "-1") {
          message = this.getLabel('mandatory_field');
          this.responseModel.piegatureIsValid = false;
        }
        else {
          this.responseModel.piegatureIsValid = true;
        }

        if (this.responseModel.piegature != null) {
          this.responseModel.piegatureCount = this.responseModel.piegature.filter(x => x.isVisible == true).length;
        }

        this.responseModel.piegatureMessage = message;
      }

      validationPlastificazione() {
        let message;

        if (this.responseModel.idPlastificazioni1 == "-1") {
          if (this.responseModel.isPlastificazioneRequired == true) {
            message = this.getLabel('mandatory_field');
            this.responseModel.plastificazione1IsValid = false;
          }
          else {
            this.responseModel.plastificazione1IsValid = true;
          }
        }
        else {
          this.responseModel.plastificazione1IsValid = true;
        }

        if (this.responseModel.plastificazioni1 != null) {
          this.responseModel.plastificazioni1Count = this.responseModel.plastificazioni1.filter(x => x.isVisible == true).length;
        }

        this.responseModel.plastificazione1Message = message;
      }

      getLabel(label) {
        let message;

        this.translate.get(label, this.translate).subscribe((res: string) => {
          message = res;
        });

        return message;
      }

      isTaglioCalculated() {
        let result: boolean = false;

        if (this.responseModel.isTaglioVisible == false) {
          if (this.responseModel.tipoCalcoloTaglio == "si" && !this.responseModel.taglioShowed) {
            result = true;
          }
          else if (this.responseModel.tipoCalcoloTaglio == "no" && !this.responseModel.taglioShowed) {
            result = false;
          }
          else if (this.responseModel.taglioShowed) {
            result = this.responseModel.tipoTaglio;
          }
        }
        else {
          result = false;
        }

        return result;
      }

      checkIsPlastificazioneInternoIsShowed() {
        let result: boolean = false;

        if (this.responseModel.plastificazioni1 != null && this.responseModel.plastificazioni1.length > 0) {
          result = true;
          if (this.responseModel.isPlastificazioneRequired == false) {
            if (this.responseModel.plastificazioni1.filter((x: any) => x.isVisible == true).length > 0) {
              result = true;
            }
            else {
              result = false;
            }
          }
        }


        return result;
      }

      isAttributeFixed(tipoLavorazione) {
        let result: boolean = false;

        if (tipoLavorazione == 'fisso') {
          result = true;
        }

        return result;
      }

      checkIsLavorazioneAccessoriaCheckShowed(tipo, tipoSelezione, isVisible) {
        let result: boolean = false;

        if (tipo == 0 && isVisible && tipoSelezione != "nascosto") {
          result = true;
        }

        return result;
      }

      checkIsLavorazioneAccessoriaNumericShowed(tipo, isVisible) {
        let result: boolean = false;

        if (tipo == 1 && isVisible) {
          result = true;
        }

        return result;
      }
      checkIsLavorazioneAccessoriaTextAreaShowed(tipo, isVisible) {
        let result: boolean = false;

        if (tipo == 6 && isVisible) {
          result = true;
        }

        return result;
      }
      textAreaCheck(event: any) {
        if (event.keyCode == 124 || event.keyCode == 38 || event.keyCode == 36 || event.keyCode == 59) {
          return false;
        }
        return true;
      }
      InputNumberCheck(event: any) {
        let result = false;
        if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode == 44 || event.keyCode == 46)) {
          result = true;
        }
        return result;
      }
      checkIsLavorazioneAccessoriaComboShowed(tipo, selectedValue, lavId) {
        let result: boolean = false;
        let isVisible: boolean = false;

        for (let lavorazioniAccessorie of this.responseModel.lavorazioniAccessorie) {
          if (lavorazioniAccessorie.id == lavId) {
            isVisible = lavorazioniAccessorie.isVisible;
          }
        }

        if (tipo == 2 && isVisible) {
          result = true;
        }

        return result;
      }

      checkIsLavorazioneAccessoriaDescrittivoShowed(tipo, isVisible) {
        let result: boolean = false;

        if (tipo == 5 && isVisible) {
          result = true;
        }

        return result;
      }

      checkIsTaglioShowed() {
        let result: boolean = false;

        if (this.responseModel.taglioShowed && !this.responseModel.isTaglioVisible) {
          result = true;
        }

        return result;
      }

      onCategoriaCartaInternoFieldChanged() {
        let selectedPaper = false;

        for (let carte of this.responseModel.carte1) {
          if (this.responseModel.idCategorieCarte1 != "-1") {
            if (carte.parentId == this.responseModel.idCategorieCarte1) {
              if (selectedPaper == false) {
                this.responseModel.idCarte1 = carte.chiave;
                this.model.idCarte1 = carte.chiave;
                this.responseModel.carte1Description = carte.descrizione;
                this.responseModel.carte1Image = carte.image;
                this.responseModel.carte1HasInfo = carte.hasInfo;
                this.responseModel.carte1ShowInfo = false;

                this.responseModel.grammature1 = carte.subElements;
                this.responseModel.idGrammature1 = carte.wrap_valore;
                this.model.idGrammature1 = carte.wrap_valore;
                selectedPaper = true;
              }

              carte.isVisible = true;
            }
            else {
              carte.isVisible = false;
            }
          }
          else {
            if (selectedPaper == false) {
              this.responseModel.idCarte1 = carte.chiave;
              this.model.idCarte1 = carte.chiave;
              this.responseModel.carte1Description = carte.descrizione;
              this.responseModel.carte1Image = carte.image;
              this.responseModel.carte1HasInfo = carte.hasInfo;
              this.responseModel.carte1ShowInfo = false;

              this.responseModel.grammature1 = carte.subElements;
              this.responseModel.idGrammature1 = carte.wrap_valore;
              this.model.idGrammature1 = carte.wrap_valore;
              selectedPaper = true;
            }

            carte.isVisible = true;
          }
        }
        this.parameterValidation();
      }

      onCartaInternoFieldChanged(isrules = false) {
        for (let grammature of this.responseModel.carte1) {
          if (grammature.chiave == this.responseModel.idCarte1) {
            this.responseModel.carte1Description = grammature.descrizione;
            this.responseModel.carte1Image = grammature.image;
            this.responseModel.carte1HasInfo = grammature.hasInfo;
            this.responseModel.carte1ShowInfo = false;
            this.responseModel.grammature1 = grammature.subElements;
            this.responseModel.idGrammature1 = grammature.wrap_valore;
            this.model.idGrammature1 = grammature.wrap_valore;
          }
        }
        if (isrules == false) {
          this.parameterValidation();
        }
      }

      onCartaInternoVisualFieldChanged(paperId) {
        this.responseModel.idCarte1 = paperId;
        this.onCartaInternoFieldChanged();
      }

      onFormatiChange(isrules = false) {
        if (this.responseModel.idFormati == "-1") {
          this.responseModel.formatoDescription = "";
          this.responseModel.formatoImage = "";
          this.responseModel.formatiHasInfo = false;
          this.responseModel.formatiShowInfo = false;
        }
        else {
          for (let formato of this.responseModel.formati) {
            if (formato.chiave == this.responseModel.idFormati) {
              this.responseModel.formatoDescription = formato.descrizione;
              this.responseModel.formatoImage = formato.image;
              this.responseModel.formatiHasInfo = formato.hasInfo;
              this.responseModel.formatiShowInfo = false;
            }
          }
        }
        if (isrules == false) {
          this.parameterValidation();
        }
      }
      packangingProfonditaChange = false;
      packangingBaseChange = false;
      onBasePackagingChange() {
        this.packangingBaseChange = false;
        this.packangingProfonditaChange = false;
        if (this.responseModel.listaPackagingParameter.length > 0 && this.responseModel.listaPackagingParameter != null) {
          for (let base of this.responseModel.listaPackagingParameter) {
            if (base.IdBase == this.responseModel.idBasePackaging) {
              this.listaProfonditaPackaging = base.listPackagingRelProfondita;
              if (this.listaProfonditaPackaging != null && this.listaProfonditaPackaging.length > 0) {
                this.packangingProfonditaChange = true;
                this.packangingBaseChange = true;
                this.responseModel.idProfonditaPackaging = this.listaProfonditaPackaging[0].IdProfondita;
                this.onProfonditaPackagingChange();
              }
              else {
                this.responseModel.formati = new Array<any>();
                this.responseModel.idProfonditaPackaging = 0;
                this.onFormatiVisualChange("-1");
              }
            }
          }
        }
        else {
          this.responseModel.idBasePackaging = 0;
          this.responseModel.idProfonditaPackaging = 0;
          this.onFormatiVisualChange("-1");
        }
        if (this.packangingProfonditaChange == false) {
          this.parameterValidation();
          this.packangingBaseChange = false

        }
      }

      onProfonditaPackagingChange() {
        if (this.listaProfonditaPackaging.length > 0 && this.listaProfonditaPackaging != null) {
          let firstFormato = 0;
          for (let profondita of this.listaProfonditaPackaging) {

            if (profondita.IdProfondita == this.responseModel.idProfonditaPackaging && profondita.IdBase == this.responseModel.idBasePackaging) {
              this.responseModel.formati = new Array<any>();

              if (profondita.listPackagingRelFormato.length > 0 && profondita.listPackagingRelFormato != null) {
                let idFIrstFormat = "0";

                profondita.listPackagingRelFormato.forEach((formatiRel: any) => {
                  let stringId = formatiRel.IdFormato + "";
                  this.listaFormatiFull.filter((x: any) => x.chiave == stringId).forEach((formato: any) => {
                    this.responseModel.formati.push(formato);
                    if (firstFormato == 0) {
                      firstFormato++;
                      idFIrstFormat = formato.chiave;
                    }
                  });
                });
                //select firsformato
                if (idFIrstFormat != "0") {
                  firstFormato++;
                  this.packangingProfonditaChange = true;
                  this.onFormatiVisualChange(idFIrstFormat)
                }
              }
              else {
                this.responseModel.formati = new Array<any>();
                this.onFormatiVisualChange("-1");
              }

              break;
            }
          }
        }
        else {
          this.responseModel.formati = new Array<any>();
          this.onFormatiVisualChange("-1");
        }
        // console.log("qui3")
        // if (this.packangingBaseChange == true ) {
        //   this.parameterValidation();
        // }
      }

      onFormatiVisualChange(formatId) {
        this.responseModel.idFormati = formatId;
        this.onFormatiChange();
      }

      onStampaInternoVisualChange(stampaInternoValue) {
        this.responseModel.idColori1 = stampaInternoValue;
        this.parameterValidation();
      }

      onStampaRetroVisualChange(stampaCopertinaValue) {
        this.responseModel.idColori2 = stampaCopertinaValue;
        this.parameterValidation();
      }

      onGrammatureInternoVisualFieldChanged(grammatureId) {
        this.responseModel.idGrammature1 = grammatureId;
        this.parameterValidation();
      }

      onPlastificationInternoChange(isrules = false) {
        for (let plastification of this.responseModel.plastificazioni1) {
          if (plastification.chiave == this.responseModel.idPlastificazioni1) {
            this.responseModel.plastificazioni1Description = plastification.descrizione;
            this.responseModel.plastificazioni1Image = plastification.image;
            this.responseModel.plastificazioni1HasInfo = plastification.hasInfo;
            this.responseModel.plastificazioni1ShowInfo = false;
          }
        }
        if (isrules == false) {
          this.parameterValidation();
        }
      }

      onPlastificationInternoViasualChange(plastificationId) {
        this.responseModel.idPlastificazioni1 = plastificationId;
        this.onPlastificationInternoChange();
      }

      lavorazioniAccessorieComboChange(lavorazione, isrules = false) {
        for (let variante of lavorazione.valori) {
          if (lavorazione.valore == variante.chiave) {
            lavorazione.description = variante.descrizione;
            lavorazione.image = variante.image;
            lavorazione.hasInfo = variante.hasInfo;
            lavorazione.showInfo = false;
          }
        }
        if (isrules == false) {
          this.parameterValidation();
        }
      }

      lavorazioniAccessorieComboVisualChange(lavorazioneId, lavorazione) {
        lavorazione.valore = lavorazioneId;
        this.lavorazioniAccessorieComboChange(lavorazione);
      }

      onPiegaturaChange(isrules = false) {
        for (let piegatura of this.responseModel.piegature) {
          if (piegatura.chiave == this.responseModel.idPiegature) {
            this.responseModel.piegatureDescription = piegatura.descrizione;
            this.responseModel.piegatureImage = piegatura.image;
            this.responseModel.piegatureHasInfo = piegatura.hasInfo;
            this.responseModel.piegatureShowInfo = false;
          }
        }
        if (isrules == false) {
          this.parameterValidation();
        }
      }

      onPiegaturaVisualChange(piegaturaId) {
        this.responseModel.idPiegature = piegaturaId;
        this.onPiegaturaChange();
      }



      showHidePiegatureDescription() {
        if (this.responseModel.piegatureShowInfo) {
          this.responseModel.piegatureShowInfo = false;
        }
        else {
          this.responseModel.piegatureShowInfo = true;
        }
      }

      showHideLavDescription(lavorazione) {
        if (lavorazione.showInfo) {
          lavorazione.showInfo = false;
        }
        else {
          lavorazione.showInfo = true;
        }
      }

      showHideFormatDescription() {
        if (this.responseModel.formatiShowInfo) {
          this.responseModel.formatiShowInfo = false;
        }
        else {
          this.responseModel.formatiShowInfo = true;
        }
      }

      showHidePaperInternoDescription() {
        if (this.responseModel.carte1ShowInfo) {
          this.responseModel.carte1ShowInfo = false;
        }
        else {
          this.responseModel.carte1ShowInfo = true;
        }
      }

      showHidePlastficationInternoDescription() {
        if (this.responseModel.plastificazioni1ShowInfo) {
          this.responseModel.plastificazioni1ShowInfo = false;
        }
        else {
          this.responseModel.plastificazioni1ShowInfo = true;
        }
      }

      isCalculationTypeCalcolato() {
        let result: boolean = false;

        if (this.responseModel.calculationType == "calcolato") {
          result = true;
        }

        return result;
      }

      isCalculationTypeCalcolatoScontistica() {
        let result: boolean = false;

        if (this.responseModel.calculationType == "calcolato_scontistica") {
          result = true;
        }

        return result;
      }

      isCalculationTypeCalcolatoQuotigPrev() {
        let result: boolean = false;

        if (this.responseModel.calculationType == "calcolato_richiesta_preventivo") {
          result = true;
        }

        return result;
      }

      isCalculationTypeListino() {
        let result: boolean = false;

        if (this.responseModel.calculationType == "listino") {
          result = true;
        }

        return result;
      }

      isCalculationTypeListinoScontistica() {
        let result: boolean = false;

        if (this.responseModel.calculationType == "listino_scontistica") {
          result = true;
        }

        return result;
      }

      addToCartWizardCalcolato(quantityId: number) {
        let wizardId = this.resourceId;
        this.resultCalculation = false;
        $('#quotingFormCalculationLoader').addClass("overBlock");
        var colType = this.resultPrice.IsHour == true ? "H" : "D";
        let sub = this.cartService.addWizardCalcolatoToCart(wizardId, this.resultPrice.RowId, colType).subscribe(result => {
          this.cartService.updateCart(result);
          this.getCalculationModel();
          $('#quotingFormCalculationLoader').removeClass("overBlock");
          this.bootboxService.i18nAlert("productAddedToCart");
          this.resultCalculation = true;
        },
          err => {
            $('#quotingFormCalculationLoader').removeClass("overBlock");
            this.bootboxService.i18nAlert("errorMex");
            this.resultCalculation = true;
          }
        );

        this.subManager.add(sub);
      }

      addToCartWizardCalcolatoScontistica(quantityId: number) {
        let wizardId = this.resourceId;

        this.resultCalculation = false;
        $('#quotingFormCalculationLoader').addClass("overBlock");
        var colType = this.resultPrice.IsHour == true ? "H" : "D";
        let sub = this.cartService.addWizardCalcolatoScontisticaToCart(wizardId, this.resultPrice.QuantityID, this.resultPrice.RowId, colType).subscribe(result => {
          this.cartService.updateCart(result);
          this.getCalculationModel();
          $('#quotingFormCalculationLoader').removeClass("overBlock");
          this.bootboxService.i18nAlert("productAddedToCart");
          this.resultCalculation = true;
        },
          err => {
            $('#quotingFormCalculationLoader').removeClass("overBlock");
            this.bootboxService.i18nAlert("errorMex");
            this.resultCalculation = true;
          }
        );

        this.subManager.add(sub);
      }

      addToCartWizardListino(quantityId: number) {
        let wizardId = this.resourceId;

        this.resultCalculation = false;
        $('#quotingFormCalculationLoader').addClass("overBlock");
        var colType = this.resultPrice.IsHour == true ? "H" : "D";
        let sub = this.cartService.addWizardListinoToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, colType).subscribe(result => {
          this.cartService.updateCart(result);
          $('#quotingFormCalculationLoader').removeClass("overBlock");
          this.bootboxService.i18nAlert("productAddedToCart");
          this.resultCalculation = true;
        },
          err => {
            $('#quotingFormCalculationLoader').removeClass("overBlock");
            this.bootboxService.i18nAlert("errorMex");
            this.resultCalculation = true;
          }
        );

        this.subManager.add(sub);
      }

      addToCartWizardListinoScontistica(quantityId: number) {
        let wizardId = this.resourceId;

        this.resultCalculation = false;
        $('#quotingFormCalculationLoader').addClass("overBlock");
        var colType = this.resultPrice.IsHour == true ? "H" : "D";
        let sub = this.cartService.addWizardListinoScontisticaToCart(this.resultPrice.RowId, this.resultPrice.QuantityID, this.resultPrice.DataId, colType).subscribe(result => {
          this.cartService.updateCart(result);
          $('#quotingFormCalculationLoader').removeClass("overBlock");
          this.bootboxService.i18nAlert("productAddedToCart");
          this.resultCalculation = true;
        },
          err => {
            $('#quotingFormCalculationLoader').removeClass("overBlock");
            this.bootboxService.i18nAlert("errorMex");
            this.resultCalculation = true;
          }
        );

        this.subManager.add(sub);
      }

      setActive(id) {
        $(".calendar-list").removeClass("hoverActive");
        $($(".calendar-list")[id]).addClass("hoverActive");
      }

      selectFileCombination() {
        this.listaFile = new Array<FileCombinationModel>()
        for (let file of this.responseModel.FilesCombinazioniObj.listaFilesCombinazioni) {
          if (file.FormatId == this.responseModel.idFormati) {

            if (this.responseModel.piegature != null) {
              if (file.PiegaId == this.responseModel.idPiegature) {
                let fileObj = new FileCombinationModel();
                fileObj.PathFile = file.PathFile;
                if (file.NomeFile == null || file.NomeFile == "") {
                  fileObj.NomeFile = file.FileName;
                }
                else {
                  fileObj.NomeFile = file.NomeFile;
                }
                fileObj.PathIstruzioni = file.PathIstruzioni;
                if (file.NomeIstruzioni == null || file.NomeIstruzioni == "") {
                  fileObj.NomeIstruzioni = file.FileIstructionName
                }
                else {
                  fileObj.NomeIstruzioni = file.NomeIstruzioni;
                }
                this.listaFile.push(fileObj)
              }
            }
            else {
              let fileObj = new FileCombinationModel();
              fileObj.PathFile = file.PathFile;
              if (file.NomeFile == null || file.NomeFile == "") {
                fileObj.NomeFile = file.FileName;
              }
              else {
                fileObj.NomeFile = file.NomeFile;
              }
              fileObj.PathIstruzioni = file.PathIstruzioni;
              if (file.NomeIstruzioni == null || file.NomeIstruzioni == "") {
                fileObj.NomeIstruzioni = file.NomeIstruzioni;
              }
              else {
                fileObj.NomeIstruzioni = file.FileIstructionName;
              }
              this.listaFile.push(fileObj)
            }
          }
        }
      }

      setPriceResult(price: any) {


        // console.log("price1")
        // console.log(price)

        if (price.Price == -1) {
          return;
        }
        // console.log("this.resultPrice")
        // console.log(this.resultPrice)

        //Deselecting the current price and selected the one passed in input
        for (let prices of this.resultPrice.TablePriceList) {
          prices.IsSelected = false;
        }

        price.IsSelected = true;
        // console.log("price2")
        // console.log(price)
        this.resultPrice.Currency = price.Currency;
        this.resultPrice.Imponibile = price.StrDiscountedPrice;
        this.resultPrice.DataId = price.DayId;
        this.resultPrice.DayName = price.DayName;
        this.resultPrice.DayNumber = price.DayNumber;
        this.resultPrice.QuantityID = price.QuantityId;
        this.resultPrice.Quantity = price.Quantity;
        this.resultPrice.IsHour = price.IsHour;
        this.resultPrice.TimePickup = price.TimePickup;

        this.resultPrice.UnitPrice = price.StrUnitPrice;
        this.resultPrice.Iva = price.StrIva;
        this.resultPrice.Total = price.StrDiscountedPriceWithTax;
        this.resultPrice.TotalAmount = price.Total;
        this.resultPrice.Weight = price.StrWeight;
        this.resultPrice.WeightUm = price.StrWeightUm;
        this.resultPrice.PrezzoOriginalestato = price.PrezzoOriginalestato;
        this.resultPrice.PrezzoOriginaleimporto = price.PrezzoOriginaleimporto;
      }

      setListinoScontisticaPriceResult(price: any) {
        if (price.Price == -1) {
          return;
        }

        this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
        this.setPriceResult(price);
      }
      setListinoPriceResult(price: any) {
        if (price.Price == -1) {
          return;
        }
        this.setSelectedIndex(price.RowIndex, price.ColumnIndex);
        this.setPriceResult(price);
      }
      isCustomerLoggedIn() {
        return this.loggedIdUser.isAuthenticated;
      }

      checkEmailIsValid() {
        var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (this.model.richiestaEmail == "" || !EMAIL_REGEXP.test(this.model.richiestaEmail)) {
          this.model.isRichiestaEmailValid = false;
        }
        else {
          this.model.isRichiestaEmailValid = true;
        }
      }

      checkFormRichiestaPrevIsValid() {
        let result: boolean = false;

        if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && !this.isCustomerLoggedIn()) {
          if (this.model.richiestaName != ""
            && this.model.richiestaSubName != ""
            && this.model.isRichiestaEmailValid
            && this.model.richiestaTelephone != ""
            && this.model.richiestaJobname != ""
            && this.model.richiestaCondizioni) {
            result = true;
          }
        }
        else if (this.responseModel.calculationType == "calcolato_richiesta_preventivo" && this.isCustomerLoggedIn()) {
          if (this.model.richiestaJobname != "") {
            result = true;
          }
        }
        return result;
      }

      sendRequestInfo() {
        if (this.checkFormRichiestaPrevIsValid()) {
          this.resultCalculation = false;
          $('#quotingFormCalculationLoader').addClass("overBlock");
          let sub = this._quotingService.sendRequestInfo(this.model).subscribe(result => {
            if (result == true) {
              this.requestInfoSuccess = true;
            }
            else {
              this.requestInfoSuccess = false;
            }
            $('#quotingFormCalculationLoader').removeClass("overBlock");
            this.resultCalculation = true;

          },
            err => {
              this.requestInfoSuccess = false;
              $('#quotingFormCalculationLoader').removeClass("overBlock");
              this.resultCalculation = true;
            }
          );

          this.subManager.add(sub);
        }
      }
      ngAfterViewChecked() {
        if (!this.isBrowser || this.pageIsInitAfter) {
          return;
        }
        layoutTheme.initToggle();
        this.pageIsInitAfter = true;
      }

      ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
      }
    }

    return ChildComponent;
  }
}




// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/document/widget/quoting/wizard/form/wizard-form-commerciale.component.ts